// Analytics orchestrator.
//
// Single entry point for analytics boot. Two tiers:
//   • Umami - cookieless & anonymous (EU-hosted). Sets no cookies, no persistent
//     id, no PII, so it does NOT require consent and loads UNCONDITIONALLY for
//     100% of traffic. Captures visitors who decline/ignore the cookie banner.
//   • GA4 + GTM + Clarity - cookie-based, consent-gated. Only injected once the
//     user has granted consent; subscribes to consent changes so a fresh Accept
//     loads them immediately without a page reload. Clarity additionally records
//     session replays, so it is consent-gated on two grounds, not just cookies.
// Feature code calls `initAnalytics()` once on boot.

import { consent, type ConsentStatus } from '../consent'
import { loadGtm } from './gtm'
import { loadGa4 } from './ga'
import { loadUmami } from './umami'
import { loadClarity } from './clarity'

let unsubscribe: (() => void) | null = null

function applyStatus(status: ConsentStatus): void {
  if (status !== 'granted') return
  loadGtm()
  loadGa4()
  loadClarity()
}

export function initAnalytics(): void {
  // Cookieless/anonymous - no consent required, fires for everyone.
  loadUmami()

  // Cookie-based - consent-gated.
  applyStatus(consent.get())
  unsubscribe?.()
  unsubscribe = consent.subscribe(applyStatus)
}

export function _teardownAnalyticsForTesting(): void {
  unsubscribe?.()
  unsubscribe = null
}
